<template>
    <div>
        <div>
            <el-form label-position="right" label-width="120px">
                <el-form-item label="仓库名">
                    <el-input v-model="filter.storeName" size="small"
                              type="textarea"
                              placeholder="仓库名" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="filter.type"
                        clearable placeholder="类型"
                        style="width: 200px;">
                        <el-option
                                v-for="item in types"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleStoreWarehouse()"
                       :loading="button_loading">保存
            </el-button>
        </div>
    </div>

</template>

<script>
    import store from '@/store'
    export default {
        name: "Dialogs_StoreWarehouse",
        data() {
            return {
                filter:{
                    storeName:'',
                    type:'',
                },
                button_loading:false,
                types:[
                    {
                        id:1,
                        name:'出售仓'
                    },
                    {
                        id:2,
                        name:'出租仓'
                    },
                ]
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleStoreWarehouse(){
                this.button_loading=true;
                this.$axios.post(store.state.server + '/createStore', {
                    'storeName': this.filter.storeName,
                    'type': this.filter.type
                }).then((response) => {
                    if (response.data.code == '0000') {
                        this.button_loading=false;
                        this.$Win.closeModal()
                    }
                }).catch((res) => {
                    this.button_loading=false;
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });
                })
            }
        }
    }
</script>

<style scoped>

</style>